// extracted by mini-css-extract-plugin
module.exports = {"spinner":"_025a50318d--spinner--YYHWw","circle-spin":"_025a50318d--circle-spin--Sbn3c"};